/**
 * =========================================================================
 * ADMIN APPLICATION ROUTER
 * =========================================================================
 * 
 * This is the root router component for the admin application.
 * It configures React Router for admin-only functionality.
 * 
 * Key Features:
 * - Admin-only route management
 * - Admin authentication handling
 * - Simple error handling
 * - Centralized admin route organization
 * 
 * Route Organization:
 * - Admin authentication (login)
 * - Admin dashboard (analytics, stats)
 * - User management (view, manage all users)
 * - Subscription management (view, modify subscriptions)
 * - Payment management (view, track payments)
 * =========================================================================
 */

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminRoutes from "./routes/admin/adminRoutes";
import NotFound from "./pages/404";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Admin Routes */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        
        {/* Root redirect to admin */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
        
        {/* 404 Catch-all Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
